import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'lib-confirm-print-dialog',
  templateUrl: './confirm-print-dialog.component.html',
  styleUrl: './confirm-print-dialog.component.scss'
})
export class ConfirmPrintDialogComponent implements OnInit , OnDestroy {
 salutationValue: 'yes' | 'no';
  constructor(
     public dialogRef: MatDialogRef<ConfirmPrintDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
  ) { }

  ngOnInit(): void {
    this.salutationValue ='no';
  }
  ngOnDestroy(): void {
      
  }
   buttonClick(value) {
    if(value==='yes'){
    let data = this.salutationValue==='yes'?{salutationValue:true}:{salutationValue:false};
    this.dialogRef.close(data);   
    }else{
      this.dialogRef.close();
    }
  }

}
